import { ProductFeatureType } from './product-feature-type';

export class ProductFeature {
  id: number = null;
  name: string = null;
  typeId: ProductFeatureType = null;
  productId: number = null;
  value: string = null;
}
